module.exports = __webpack_public_path__ + "static/salesandconditions-bbab83f0c990b6a10f2def8a97d50883.pdf";